module.exports = __webpack_public_path__ + "static/media/luxanna.6c3055eb.png";